import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Card,
  Button,
  Table,
  CardBody,
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  InputGroupAddon,
  InputGroupText,
  Input,
  InputGroup,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  ModalHeader,
  ModalBody,
  CardTitle,
  CardHeader,
} from "reactstrap";

import * as XLSX from "xlsx";

import "react-calendar/dist/Calendar.css";
import { api } from "../../../../api";
import { Link } from "react-router-dom";
import Cookies from "js-cookie";

const MaterialDelivery = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [projectDropdownOpen, setProjectDropdownOpen] = useState(false);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [originalData, setOriginalData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  
  
  

  useEffect(() => {
    const fetchData = async () => {
      try {
        const company_id = Cookies.get('company_id');
        const response = await api.get(`addDeliveryStock.php?company_id=${company_id}`);
        const products = response.data; 
        setOriginalData(products);
        setFilteredData(products);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
  
    fetchData();
  }, []);
  

  const [itemToDelete, setItemToDelete] = useState(null);

  const handleDeleteIconClick = (item_id) => {
    setItemToDelete(item_id);
    setShowDeleteConfirmation(true);
  };

  const handleDeleteConfirmation = async () => {
    try {
      const company_id = Cookies.get('company_id');
      const response = await api.delete(`addDeliveryStock.php?company_id=${company_id}`, {
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({ delivery_id
          : itemToDelete }),
      });
      console.log(response.data);
      window.location.reload(); // Reload the page after deletion
    } catch (error) {
      console.error("Error deleting item:", error);
    }
    setItemToDelete(null);
    setShowDeleteConfirmation(false);
  };

  const [showRoleModal, setShowRoleModal] = useState(false);
  const [showRoleModal2, setShowRoleModal2] = useState(false);
  const toggleRole = () => {
    setShowRoleModal(!showRoleModal);
  };
  const toggleRole2 = () => {
    setShowRoleModal2(!showRoleModal2);
  };

  const [role, setrole] = useState();

  const [viewrole, setviewrole] = useState();
  const [loading, setLoading] = useState(true);

  const [entriesToShow, setEntriesToShow] = useState(5);
  const [dataToShow, setDataToShow] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(filteredData.length / entriesToShow);

  useEffect(() => {
    console.log("EFFECT RUNNING - filteredData:", filteredData); // Check this log!
    console.log("EFFECT RUNNING - currentPage:", currentPage, "entriesToShow:", entriesToShow);

    // Add a check to ensure filteredData is usable
    if (!Array.isArray(filteredData)) {
         console.log("filteredData is not an array, skipping slice.");
         setDataToShow([]); // Keep it empty if source isn't ready
         return;
    }

    const startIndex = (currentPage - 1) * entriesToShow;
    const endIndex = currentPage * entriesToShow;

    console.log(`Slicing from index ${startIndex} to ${endIndex}`);

    const slicedData = filteredData.slice(startIndex, endIndex);
    console.log("Sliced Data:", slicedData); // See what slice returns

    setDataToShow(slicedData);
    // console.log("Data to show (in effect - WILL BE OLD):", dataToShow); // Avoid logging here

}, [entriesToShow, currentPage, filteredData]);

  const toggleProjectDropdown = () => {
    setProjectDropdownOpen(!projectDropdownOpen);
  };

  const handleEntriesChange = (value) => {
    setEntriesToShow(value === "All" ? filteredData.length : Number(value));
    setCurrentPage(1);
  };

  const prePage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const nextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const changeCPage = (n) => {
    setCurrentPage(n);
  };

  const handleDownload = () => {
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";
    const fileName = "stock_list";

    const formattedData = dataToShow.map((item) => ({
      "Product Id": item.product_id,
      "Product Name": item.product_name,
      "Quantity Delivered": item.quantity_delivered,
      "Delivered To Name": item.delivered_to_name,
      "Delivered ID": item.delivery_id,
      "Delivered Date": item.delivery_date,
      "Product Cost": item.product_cost,
    }));

    const ws = XLSX.utils.json_to_sheet(formattedData, {
      header: [
        "Product Id",
        "Product Name",
        "Quantity Delivered",
        "Delivered To Name",
        "Delivered ID",
        "Delivered Date",
        "Product Cost",
      ],
    });

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Stock List");

    const headerCellStyle = {
      font: { bold: true },
      fill: { bgColor: { indexed: 64 } },
    };
    Object.keys(ws)
      .filter((key) => key.startsWith("A1"))
      .forEach((key) => {
        ws[key].s = headerCellStyle;
      });

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });

    const excelData = new Blob([excelBuffer], { type: fileType });

    const excelUrl = URL.createObjectURL(excelData);

    const link = document.createElement("a");
    link.href = excelUrl;
    link.download = fileName + fileExtension;
    document.body.appendChild(link);
    link.click();

    setTimeout(function () {
      document.body.removeChild(link);
      window.URL.revokeObjectURL(excelUrl);
    }, 100);
  };

  const [addstock, setAddStock] = useState({
    product_name: "",
    quantity_delivered:"",
    delivery_date: "",
    delivered_to_name: "",
    product_cost: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setAddStock((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    console.log(addstock);
  };

  const handleFormSubmit = async (event) => {
    event.preventDefault(); // Prevent default browser form submission

    // Basic validation check (optional, but good practice)
    if (!addstock.product_name) {
      alert("Please select a product.");
      return;
    }

    const formDataToSend = {
      product_name: addstock.product_name,
      quantity_delivered: addstock.quantity_delivered,
      delivery_date: addstock.delivery_date,
      delivered_to_name: addstock.delivered_to_name,
      product_cost: addstock.product_cost,
    };

    console.log("Submitting data:", formDataToSend); // Log data before sending

    try {
      const company_id = Cookies.get('company_id');
      const response = await api.post(`addDeliveryStock.php?company_id=${company_id}`, formDataToSend);
      console.log("Data sent successfully:", response.data);
      alert("Delivery stock added successfully!"); // User feedback
      // Consider resetting the form instead of reloading the whole page for better UX
      // setAddStock({
      //   product_name: "",
      //   quantity_delivered: "",
      //   delivery_date: "",
      //   delivered_client: "",
      //   cost: "",
      // });
    //   window.location.reload(); // Reloads the page as per original code
    } catch (error) {
      console.error("Error submitting data:", error);
      alert("Error submitting data. Please check the console for details."); // User feedback on error
    }
  };

  useEffect(() => {
    if (searchQuery === "") {
      setFilteredData(originalData);
    } else {
      const filteredResults = originalData.filter(
        (item) =>
          item.product_name &&
          item.product_name.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setFilteredData(filteredResults);
    }
  }, [searchQuery, originalData]);
  console.log(dataToShow);
  console.log(dataToShow);
  

  return (
    <>
      <div className="header bg-gradient-info py-7 py-lg-8">
        <Container fluid>
          <div className="header bg-gradient-info py-5">
            <Container fluid>
              <Row className="mb-5">
                <Col
                  xs="12"
                  className="d-flex justify-content-between align-items-center flex-wrap"
                >
                  <Form className="navbar-search navbar-search-dark form-inline w-100 mb-3 mb-md-0">
                    <FormGroup className="mb-0 w-100">
                      <InputGroup className="input-group-alternative w-70">
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="fas fa-search" />
                          </InputGroupText>
                          <Input
                            placeholder="Search Stock"
                            type="text"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            className="w-100" // Adjust width of input field
                          />
                        </InputGroupAddon>
                      </InputGroup>
                      {/* Add margin to the button */}
                      {/* <div className="ml-3">
                        <Button onClick={toggleRole}>Add Stock</Button>
                        <Button onClick={toggleRole2}>Delivery Stock</Button>
                      </div> */}
                    </FormGroup>
                  </Form>
                </Col>
              </Row>
            </Container>
          </div>
          <Row className="">
            <Col xl="12" style={{ marginTop: "-20px" }}>
              <Card className="shadow">
                <CardBody>
                  <CardHeader className="border-0">
                    <Row className="align-items-center">
                      <div className="col">
                        <h3 className="mb-0">Stock List</h3>
                      </div>
                      <div className="col text-right">
                        <Dropdown
                          isOpen={projectDropdownOpen}
                          toggle={toggleProjectDropdown}
                        >
                          <DropdownToggle caret>
                            Show Entries:{" "}
                            {entriesToShow === filteredData.length
                              ? "All"
                              : entriesToShow}
                          </DropdownToggle>
                          <DropdownMenu>
                            <DropdownItem
                              onClick={() => handleEntriesChange(5)}
                            >
                              5
                            </DropdownItem>
                            <DropdownItem
                              onClick={() => handleEntriesChange(10)}
                            >
                              10
                            </DropdownItem>
                            <DropdownItem
                              onClick={() => handleEntriesChange(50)}
                            >
                              50
                            </DropdownItem>
                            <DropdownItem
                              onClick={() => handleEntriesChange("All")}
                            >
                              All
                            </DropdownItem>
                          </DropdownMenu>
                        </Dropdown>
                        <button
                          className="btn btn-success mr-2"
                          onClick={handleDownload}
                        >
                          Download
                        </button>
                      </div>
                    </Row>
                  </CardHeader>
                  <Table className="align-items-center table-flush" responsive>
                    <thead className="thead-light">
                      <tr>
                        <th scope="col">Item Id</th>
                        <th scope="col">Product Name</th>
                        <th scope="col">Quantity Delivered</th>
                        <th scope="col">Delivered Date</th>
                        <th scope="col">Delivered Client</th>
                        <th scope="col">Cost</th>
                        <th scope="col">Material Tracking Number</th>
                        <th scope="col">Action</th>
                      </tr>
                    </thead>
                    <tbody style={{ textAlign: "center" }}>
                      {Array.isArray(dataToShow) && dataToShow.map((item, index)=> (
                        <tr key={index}>
                          <th scope="row">{index+1}</th>
                          <td>{item.product_name}</td>
                          <td>{item.quantity_delivered}</td>
                            <td>{item.delivery_date}</td>
                            <td>{item.delivered_to_name}</td>
                          <td>{item.product_cost}</td>
                          <td>{item.material_tracking_number}</td>
                          <td
                            style={{
                              display: "flex",
                              justifyContent: "space-evenly",
                            }}
                          >
                            {/* <Link
                              to={`/store-admin/store-management/editstock4/${item.product_id}`}
                              style={{ marginRight: "10px" }}
                            >
                              <i
                                className="fa-solid fa-pen"
                                style={{
                                  fontSize: "23px",
                                  color: "green",
                                  cursor: "pointer",
                                }}
                              ></i>
                            </Link> */}
                            <i
                              className="fa fa-trash"
                              style={{
                                fontSize: "23px",
                                color: "red",
                                cursor: "pointer",
                              }}
                              onClick={() =>
                                handleDeleteIconClick(item.delivery_id
                                )
                              }
                            ></i>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                  <nav className="mt-3">
                    <ul className="pagination justify-content-center">
                      <li className="page-item">
                        <a
                          href="#"
                          className="page-link text-primary"
                          onClick={prePage}
                          disabled={currentPage === 1}
                        >
                          Prev
                        </a>
                      </li>
                      <li className="page-item">
                        <a
                          href="#"
                          className="page-link text-primary"
                          onClick={nextPage}
                          disabled={currentPage === totalPages}
                        >
                          Next
                        </a>
                      </li>
                    </ul>
                  </nav>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Modal
            isOpen={showDeleteConfirmation}
            toggle={() => setShowDeleteConfirmation(false)}
          >
            <ModalHeader>Confirm Deletion</ModalHeader>
            <ModalBody>Are you sure you want to delete this material ?</ModalBody>
            <div className="modal-footer">
              <Button color="danger" onClick={handleDeleteConfirmation}>
                Yes
              </Button>
              <Button
                color="secondary"
                onClick={() => setShowDeleteConfirmation(false)}
              >
                No
              </Button>
            </div>
          </Modal>
          <Modal isOpen={showRoleModal} toggle={toggleRole}>
            <ModalHeader toggle={toggleRole}>
              <h2 style={{ fontWeight: "bolder", textTransform: "uppercase" }}>
                New Stock
              </h2>
            </ModalHeader>
            <ModalBody>
              <Form onSubmit={handleFormSubmit}>
                <Row className="mb-4">
                  <Col md={6}>
                    <label className="form-control-label" htmlFor="input-role">
                      Enter Product Name
                    </label>
                    <Input
                      name="product_name"
                      className="form-control-alternative"
                      id="input-role"
                      type="text"
                      onChange={handleInputChange}
                      placeholder="Enter Product Name"
                      required
                    />
                  </Col>
                  <Col md={6}>
                    <label className="form-control-label" htmlFor="input-role">
                      Enter Total Stock
                    </label>
                    <Input
                      className="form-control-alternative"
                      id="input-role"
                      type="number"
                      name="total_stock"
                      onChange={handleInputChange}
                      placeholder="Enter Total Stock"
                      required
                    />
                  </Col>
                </Row>
                <Row className="mb-4">
                  <Col md={6}>
                    <label className="form-control-label" htmlFor="input-role">
                      Enter Current Stock
                    </label>
                    <Input
                      className="form-control-alternative"
                      id="input-role"
                      type="number"
                      name="available_stock"
                      onChange={handleInputChange}
                      placeholder="Enter Current Stock"
                      required
                    />
                  </Col>
                  <Col md={6}>
                    <label className="form-control-label" htmlFor="input-role">
                      Enter Cost / Unit
                    </label>
                    <Input
                      className="form-control-alternative"
                      id="input-role"
                      type="text"
                      name="cost"
                      onChange={handleInputChange}
                      placeholder="Enter Cost/Unit"
                      required
                    />
                  </Col>
                </Row>

                <Row>
                  <Col lg="12" style={{ textAlign: "center" }}>
                    <Button color="primary" type="submit">
                      Submit
                    </Button>
                  </Col>
                </Row>
              </Form>
            </ModalBody>
          </Modal>

          <Modal isOpen={showRoleModal2} toggle={toggleRole2}>
            <ModalHeader toggle={toggleRole2}>
              <h2 style={{ fontWeight: "bolder", textTransform: "uppercase" }}>
                Delivery Stock
              </h2>
            </ModalHeader>
            <ModalBody>
              <Form onSubmit={handleFormSubmit}>
                <Row className="mb-4">
                  <Col md={6}>
                    <label className="form-control-label" htmlFor="input-role">
                      Enter Product Name
                    </label>
                    <select
                      name="product_name"
                      className="form-select form-control-alternative custom-select" // Added Bootstrap classes
                      id="input-role"
                      onChange={handleInputChange}
                      required
                      style={{
                        padding: "0.75rem 1rem",
                        fontSize: "0.875rem",
                        fontWeight: "400",
                        lineHeight: "1.5",
                        color: "#495057",
                        backgroundColor: "#fff",
                        backgroundClip: "padding-box",
                        border: "1px solid #ced4da",
                        borderRadius: "0.375rem",
                        transition:
                          "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
                        height: "calc(2.75rem + 2px)",
                        width: "100%",
                      }}
                    >
                      <option value="" disabled>
                        Select Product
                      </option>
                      {originalData.map((item) => (
                        <option
                          key={item.product_id}
                          value={item.product_name}
                          style={{
                            padding: "0.5rem 1rem",
                            fontSize: "0.875rem",
                          }}
                        >
                          {item.product_name}
                        </option>
                      ))}
                    </select>
                  </Col>
                  <Col md={6}>
                    <label className="form-control-label" htmlFor="input-role">
                      Enter Quantity Delivered
                    </label>
                    <Input
                      className="form-control-alternative"
                      id="input-role"
                      type="text"
                      name="quantity_delivered"
                      onChange={handleInputChange}
                      placeholder="Enter Total Stock"
                      required
                    />
                  </Col>
                </Row>
                <Row className="mb-4">
                  <Col md={6}>
                    <label className="form-control-label" htmlFor="input-role">
                      Enter Delivery Date
                    </label>
                    <Input
                      className="form-control-alternative"
                      id="input-role"
                      type="date"
                      name="delivery_date"
                      onChange={handleInputChange}
                      placeholder="Enter Current Stock"
                      required
                    />
                  </Col>
                  <Col md={6}>
                    <label className="form-control-label" htmlFor="input-role">
                      Enter Delivered Client
                    </label>
                    <Input
                      className="form-control-alternative"
                      id="input-role"
                      type="text"
                      name="delivered_to"
                      onChange={handleInputChange}
                      placeholder="Enter Delivered Client"
                      required
                    />
                  </Col>
                </Row>
                <Row className="mb-4">
                  <Col md={6}>
                    <label className="form-control-label" htmlFor="input-role">
                      Enter Cost / Unit
                    </label>

                    <Input
                      className="form-control-alternative"
                      id="input-role"
                      type="text"
                      name="product_cost"
                      onChange={handleInputChange}
                      placeholder="Enter Cost/Unit"
                      required
                    />
                  </Col>
                </Row>
                <Row>
                  <Col lg="12" style={{ textAlign: "center" }}>
                    <Button color="primary" type="submit">
                      Submit
                    </Button>
                  </Col>
                </Row>
              </Form>
            </ModalBody>
          </Modal>
        </Container>
      </div>
    </>
  );
};

export default MaterialDelivery;
